import React from 'react';

import PhoneSVG from '@app/images/PhoneSVG';
import '@app/scss/components/cardResource.scss';

const CardResource = (props) => {
	const {
		position,
		name,
		phone,
		url,
	} = props;

	return (
		<div className="card-resource">
			<a href={url} target="_blank" className="card-resource__position" rel="noopener noreferrer">
				{position}
			</a>
			<p className="card-resource__name">{name}</p>
			<a className="card-resource__phone" href={`tel:${phone}`}>
				<span className="card-resource__phone-icon">
					<PhoneSVG />
				</span>
				<span>{phone}</span>
			</a>
		</div>
	);
};

export default CardResource;
